import { Task } from './task';
import { ActionType } from './action-type.enum';
import { StationType } from './station-type.enum';
import { StationLevel } from './station-level.enum';
import { StationAssignmentStrategy } from '../../../common/station-assignment-strategy/station-assignment-strategy.model';

export class RoutingPosition {
  index: number;
  stationId: number;
  stationName: string;
  stationType: StationType;
  actionType: ActionType;
  cargo: string;
  stationLevel: StationLevel;
  waitingForRetrieve: boolean;
  cargoMandatory: boolean;
  tasks: Task[] = [];
  predictedDuration: number;
  routingRuleId: number;
  hint: string;
  processingStatusModel: string;
  readonly: boolean;
  stationAssignmentStrategy: StationAssignmentStrategy;

  constructor(rp?: RoutingPosition) {
    if (rp != null) {
      this.index = rp.index;
      this.stationId = rp.stationId;
      this.stationName = rp.stationName;
      this.stationType = rp.stationType;
      this.actionType = rp.actionType;
      this.cargo = rp.cargo;
      this.stationLevel = rp.stationLevel;
      this.waitingForRetrieve = rp.waitingForRetrieve;
      this.cargoMandatory = rp.cargoMandatory;
      if (rp.tasks != null) {
        for (const t of rp.tasks) {
          this.tasks.push(new Task(t));
        }
      }
      this.predictedDuration = rp.predictedDuration;
      this.routingRuleId = rp.routingRuleId;
      this.hint = rp.hint;
      this.processingStatusModel = rp.processingStatusModel;
      this.readonly = rp.readonly;
      this.stationAssignmentStrategy = rp.stationAssignmentStrategy;
    }
  }
}
